<template>
  <div class="hpsfir-card file">
    <HpsfirProTable
      ref="tableRef"
      title="文件管理"
      :paginations="{ pageSize: 20 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :dialog-width="600"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, computed } from 'vue';
import { useCos } from '@/hooks/useCos';
import FileSaver from 'file-saver';

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

// 原始数据存储
const allEducationStages = ref<{ label: string; value: number }[]>([]);
const allGrades = ref<{ label: string; value: number; educationStageId: number }[]>([]);
const allCategories = ref<{ label: string; value: number; gradeIds: number[] }[]>([]);

// 级联选择器选项数据
const cascaderOptions = computed(() => {
  const options: {
    value: any;
    label: string;
    children: any[];
  }[] = allEducationStages.value.map((educationStage) => ({
    value: educationStage.value,
    label: educationStage.label,
    children: allGrades.value
      .filter((grade) => grade.educationStageId === educationStage.value)
      .map((grade) => ({
        value: grade.value,
        label: grade.label,
        children: allCategories.value
          .filter((category) => category.gradeIds.includes(grade.value))
          .map((category) => ({
            value: category.value,
            label: category.label,
            children: [],
          })),
      })),
  }));
  return options;
});

const addInitValue = {

};

const conditionsInitValue = {
};


// 创建列定义
// eslint-disable-next-line max-lines-per-function
const createColumns = () => [

  {
    name: 'cascaderSelection',
    label: '教育阶段/年级/分类',
    type: 'cascader',
    options: cascaderOptions,
    isCondition: true,
    rule: [{ required: true, message: '请选择教育阶段/年级/分类' }],
    width: 200,
    render: ({ row }: any) => {
      const parts: string[] = [];

      // 获取教育阶段名称
      if (row.educationStageId) {
        const educationStage = allEducationStages.value.find((item) => item.value === row.educationStageId);
        if (educationStage) {
          parts.push(educationStage.label);
        }
      }

      // 获取年级名称
      if (row.gradeId) {
        const grade = allGrades.value.find((item) => item.value === row.gradeId);
        if (grade) {
          parts.push(grade.label);
        }
      }

      // 获取分类名称
      if (row.categoryId) {
        const category = allCategories.value.find((item) => item.value === row.categoryId);
        if (category) {
          parts.push(category.label);
        }
      }

      return parts.length > 0 ? parts.join(' / ') : '-';
    },
  },
  {
    name: 'files',
    label: '文件',
    type: 'file',
    rule: [{ required: true, message: '请上传文件' }],
    hideTable: true,
    hideEdit: true,
    multiple: true,
    httpRequest: async(options) => {
      try {
        console.log(options);
        const _res = await useCos().uploadFile(options.file);

        const dRes = await useCos().getFile(_res.url, 1);
        if (dRes.totalPage <= 0 || !dRes.imageUrl) {
          ElMessage.error('文件上传失败');
          throw new Error('文件上传失败');
        }
        options.onSuccess({
          ..._res,
          ...dRes,
        });
      } catch (error: any) {
        options.onError(error);
      }
    },
    onSuccess: (res: any) => {
      if (res) {
        console.log('options.success', res);
        const fileInfo = {
          url: res.url,
          ext: res.fileExt,
          md5: res.md5,
          pageCount: res.totalPage,
          fileSize: res.size,
          name: res.name,
          file: res.url,
        };
        if (Array.isArray(tableRef.value?.tableForm?.getFormState().files)) {
          const files = tableRef.value?.tableForm?.getFormState().files;
          if (files.find((item: any) => item.md5 === fileInfo.md5)) {
            return;
          }
          tableRef.value?.tableForm?.setOneFormState('files', [...files, fileInfo]);
        } else {
          tableRef.value?.tableForm?.setOneFormState('files', [fileInfo]);
        }

        /*  tableRef.value?.tableForm?.setOneFormState('url', res.url);
        tableRef.value?.tableForm?.setOneFormState('ext', res.fileExt);
        tableRef.value?.tableForm?.setOneFormState('md5', res.md5);
        tableRef.value?.tableForm?.setOneFormState('pageCount', res.totalPage);
        tableRef.value?.tableForm?.setOneFormState('fileSize', res.size);
        tableRef.value?.tableForm?.setOneFormState('name', res.name);
        tableRef.value?.tableForm?.setOneFormState('file', res.url); */
      }
    },
    width: 200,
  },
  {
    name: 'name',
    label: '文件名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入文件名称' }],
    hideCreate: true,
    width: 200,
  },
  {
    name: 'url',
    label: '文件URL',
    type: 'string',
    rule: [{ required: true, message: '请输入文件URL' }],
    hideCreate: true,
    hideEdit: true,
    hideTable: true,
    width: 300,
  },
  {
    name: 'ext',
    label: '文件格式',
    type: 'string',
    rule: [{ required: true, message: '请输入文件格式' }],
    hideCreate: true,
    hideEdit: true,
    width: 100,
  },
  {
    name: 'pageCount',
    label: '页数',
    type: 'number',
    hideCreate: true,
    hideEdit: true,
    width: 80,
  },
  {
    name: 'fileSize',
    label: '文件大小',
    type: 'number',
    hideCreate: true,
    hideEdit: true,
    width: 120,
    render: ({ row }: any) => `${(row.fileSize / 1024 / 1024).toFixed(2)}MB`,
  },
  {
    name: 'md5',
    label: 'MD5',
    type: 'string',
    rule: [{ required: true, message: '请输入MD5值' }],
    hideCreate: true,
    hideEdit: true,
    hideTable: true,
    width: 150,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  },
] as HpsfirProTableColumn[];

// 加载选项数据
const loadOptions = useBaseAsync(async() => {
  try {
    // 加载教育阶段
    const educationStageRes = await useApi().educationstageApi.listEducationStageeducationstage({
      conditions: {},
    });
    allEducationStages.value = (educationStageRes.data.data || []).map((item: any) => ({
      label: item.name,
      value: item.id,
    }));

    // 加载年级（包含educationStageId用于联动）
    const gradeRes = await useApi().gradeApi.listGradegrade({
      conditions: {},
    });
    allGrades.value = (gradeRes.data.data || []).map((item: any) => ({
      label: item.name,
      value: item.id,
      educationStageId: item.educationStageId,
    }));

    // 加载分类（包含gradeIds用于联动）
    const categoryRes = await useApi().categoryApi.listCategorycategory({
      conditions: {},
    });
    allCategories.value = (categoryRes.data.data || []).map((item: any) => ({
      label: item.name,
      value: item.id,
      gradeIds: item.gradeIds || [],
    }));
  } catch (error) {
    console.error('加载选项失败:', error);
    ElMessage.error('加载选项失败');
  }
});

// 初始化
const init = useBaseAsync(() => {
  columns.value = createColumns();
});

const operates: any[] = [
  {
    key: 'download',
    name: '下载',
    handler: async(row: any) => {
      try {
        if (!row.url) {
          ElMessage.error('文件URL不存在');
          return;
        }

        ElMessage.info('开始下载...');

        // 使用fetch获取文件blob
        const response = await fetch(row.url.replace('print-1356239298.cos.ap-guangzhou.myqcloud.com', 'pcos.lvxinyunyin2025.com'));

        if (!response.ok) {
          throw new Error(`下载失败: ${response.status}`);
        }

        const blob = await response.blob();

        // 使用file-saver下载文件
        const fileName = row.name || `file.${row.ext || 'unknown'}`;
        FileSaver.saveAs(blob, fileName);

        ElMessage.success('下载完成');
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error('下载失败');
      }
    },
  },
];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;

    // 处理级联选择器的筛选条件
    const processedConditions = Object.entries(filter.conditions).reduce((acc, [key, val]) => {
      if (val === null || val === undefined || val === '') {
        return acc;
      }

      // 如果是级联选择器的值，需要解析为对应的educationStageId、gradeId、categoryId
      if (key === 'cascaderSelection' && Array.isArray(val) && val.length > 0) {
        const [educationStageId, gradeId, categoryId] = val;
        if (educationStageId) {
          acc.educationStageId = educationStageId;
        }
        if (gradeId) {
          acc.gradeId = gradeId;
        }
        if (categoryId) {
          acc.categoryId = categoryId;
        }
      } else {
        acc[key] = val;
      }

      return acc;
    }, {} as any);

    const res = await useApi().fileApi.pageFilefile({
      conditions: processedConditions,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data?.map((item: any) => ({
        ...item,
        cascaderSelection: [item.educationStageId, item.gradeId, item.categoryId],
      })) || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除文件"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  // 处理级联选择器的数据
  const fileData = { ...data };
  if (data.cascaderSelection && Array.isArray(data.cascaderSelection)) {
    const [educationStageId, gradeId, categoryId] = data.cascaderSelection;
    if (educationStageId) {
      fileData.educationStageId = educationStageId;
    }
    if (gradeId) {
      fileData.gradeId = gradeId;
    }
    if (categoryId) {
      fileData.categoryId = categoryId;
    }
    delete fileData.cascaderSelection;
  }

  for (const file of fileData.files) {
    await useApi().fileApi.addFilefile({
      fileAdminVo: {
        ...file,
        educationStageId: fileData.educationStageId,
        gradeId: fileData.gradeId,
        categoryId: fileData.categoryId,
      },
    });
  }

  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  // 处理级联选择器的数据
  const fileData = { ...data };
  if (data.cascaderSelection && Array.isArray(data.cascaderSelection)) {
    const [educationStageId, gradeId, categoryId] = data.cascaderSelection;
    if (educationStageId) {
      fileData.educationStageId = educationStageId;
    }
    if (gradeId) {
      fileData.gradeId = gradeId;
    }
    if (categoryId) {
      fileData.categoryId = categoryId;
    }
    delete fileData.cascaderSelection;
  }

  await useApi().fileApi.updateFilefile({
    fileAdminVo: fileData,
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().fileApi.delFilefile(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init(), loadOptions()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
